<template>
  <div>
    <va-card>
      <vue-element-loading :active="visible" :is-full-screen="true" />
      <div class="d-flex align-items-center mb-4">
        <button @click="$router.go(-1)" class="btn btn-link p-0 mr-3"
          style="font-size: 24px; color: #007bff; text-decoration: none;" title="Back to Offenders">
          <i class="fa fa-arrow-left mr-2"></i>
        </button>
        <h4 style="font-size: 24px !important" class="text-uppercase mb-0">
          {{ isEditMode ? 'Edit' : 'Add' }} Accused/Offender
        </h4>
      </div>

      <form @submit.prevent="submitForm">
        <!-- Basic Information -->
        <div class="row">
          <div class="col-md-12">
            <h5 class="border-bottom pb-2">Basic Information</h5>
          </div>
        </div>

        <!-- Habitual Toggle -->
        <div class="row mb-3">
          <div class="col-md-12">
            <div class="card p-3 bg-light">
              <div class="d-flex align-items-center">
                <b-form-checkbox v-model="formData.isHabitual" name="check-habitual" switch size="lg" class="mr-3">
                  <span class="h6 mb-0">Mark as Habitual Offender</span>
                </b-form-checkbox>
                <small class="text-muted">Check this if the accused has a history of multiple offences.</small>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
          <div class="form-group">
            <label>Aadhar Number</label>
            <input v-model="formData.adharNo" type="text" class="form-control" :class="{
              'is-valid': aadhaarValidation.isValid && !aadhaarValidation.exists,
              'is-invalid': aadhaarValidation.isInvalid || aadhaarValidation.exists
            }" placeholder="Aadhar Number" maxlength="12" @input="validateAadhaar" @blur="validateAadhaar" />
            <div v-if="aadhaarValidation.isLoading" class="invalid-feedback d-block">
              <i class="fa fa-spinner fa-spin"></i> Checking Aadhaar number...
            </div>
            <div v-else-if="aadhaarValidation.isInvalid" class="invalid-feedback d-block">
              <i class="fa fa-exclamation-triangle"></i> Invalid Aadhaar number format. Must be 12 digits.
            </div>
            <div v-else-if="aadhaarValidation.exists" class="invalid-feedback d-block">
              <i class="fa fa-times-circle"></i> Aadhaar number already exists for: {{
                aadhaarValidation.existingData.name }} ({{ aadhaarValidation.existingData.alias }})
            </div>
            <!-- <div v-else-if="aadhaarValidation.isValid && !aadhaarValidation.exists" class="valid-feedback d-block">
                <i class="fa fa-check-circle"></i> Aadhaar number is available
              </div> -->
          </div>
        </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Name *</label>
              <input v-model="formData.name" type="text" class="form-control" required placeholder="Full Name" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Alias</label>
              <input v-model="formData.alias" type="text" class="form-control" placeholder="Alias/Nickname" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>Age *</label>
              <input v-model="formData.age" type="number" class="form-control" required min="1" max="120"
                placeholder="Age" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Gender *</label>
              <select v-model="formData.sex" class="form-control" required>
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Date of Birth</label>
              <input v-model="formData.dob" type="date" class="form-control" placeholder="Date of Birth" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Father's Name</label>
              <input v-model="formData.fathersName" type="text" class="form-control" placeholder="Father's Name" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Occupation</label>
              <input v-model="formData.occupation" type="text" class="form-control" placeholder="Occupation" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Address *</label>
              <textarea v-model="formData.address" class="form-control" rows="3" required
                placeholder="Complete Address"></textarea>
            </div>
          </div>
        </div>

        <!-- Contact Information -->
        <div class="row mt-4">
          <div class="col-md-12">
            <h5 class="border-bottom pb-2">Contact Information</h5>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Contact Number</label>
              <input v-model="formData.contactNo" type="tel" class="form-control" placeholder="Contact Number" />
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Phone Numbers</label>
              <div v-for="(phone, index) in phoneNumbers" :key="index" class="mb-2">
                <div class="input-group">
                  <input v-model="phoneNumbers[index]" type="tel" class="form-control"
                    :placeholder="`Phone Number ${index + 1}`" />
                  <div class="input-group-append" v-if="phoneNumbers.length > 1">
                    <button type="button" class="btn btn-outline-danger" @click="removePhone(index)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
              <button type="button" class="btn btn-outline-primary btn-sm mt-2" @click="addPhone">
                <i class="fa fa-plus mr-1"></i>Add Phone Number
              </button>
            </div>
          </div>
        </div>

        <!-- Physical Description -->
        <div class="row mt-4">
          <div class="col-md-12">
            <h5 class="border-bottom pb-2">Physical Description</h5>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label>Height (cm)</label>
              <input v-model="formData.height" type="number" class="form-control" placeholder="Height in cm" />
            </div>
          </div>
          <div class="col-md-3" v-if="complexions == 'complexions'">
            <div class="form-group label-floating">
              <label class="control-label" style="color: black !important;">Complexion</label>
              <select class="form-control" v-model="complexion">
                <option value="Blackish Dark">Blackish Dark</option>
                <option value="Brownish Dark">Brownish Dark</option>
                <option value="Fair">Fair</option>
                <option value="Foreigner Type Black">Foreigner Type Black</option>
                <option value="Foreigner Type White">Foreigner Type White</option>
                <option value="Sallow">Sallow</option>
              </select>
            </div>
          </div>

          <div class="col-md-3" v-if="eyess == 'eyess'">
            <div class="form-group label-floating">
              <label class="control-label" style="color: black !important;">Eyes</label>
              <select class="form-control" v-model="eyes">
                <option value="Using specs">Using specs</option>
                <option value="Normal">Normal</option>
                <option value="Cat Type">Cat Type</option>
                <option value="Conspicuously small">Conspicuously small</option>
                <option value="One Eyed">One Eyed</option>
                <option value="Markedly closely placed">Markedly closely placed</option>
                <option value="Sunken">Sunken</option>
                <option value="Freckled">Freckled</option>
                <option value="Conspicuously Large">Conspicuously Large</option>
                <option value="Slit">Slit</option>
                <option value="Markedly Widely Placed">Markedly Widely Placed</option>
                <option value="Asterisk in Eye">Asterisk in Eye</option>
                <option value="Protruding">Protruding</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3" v-if="hairs == 'hairs'">
            <div class="form-group label-floating">
              <label class="control-label" style="color: black !important;">Hair</label>
              <select class="form-control" v-model="hair">
                <option value="Normal Grey">Normal Grey</option>
                <option value="Full Bald">Full Bald</option>
                <option value="Front Bald">Front Bald</option>
                <option value="Centre Bald">Centre Bald</option>
                <option value="Side Burns">Side Burns</option>
                <option value="Curly Grey">Curly Grey</option>
                <option value="Normal">Normal</option>
                <option value="Curly Black Grey">Curly Black Grey</option>
                <option value="Curly Black">Curly Black</option>
                <option value="Using Wig">Using Wig</option>
              </select>
            </div>
          </div>
          <div class="col-md-3" v-if="bodybuilds == 'bodybuilds'">
            <div class="form-group label-floating">
              <label class="control-label" style="color: black !important;">Body Build</label>
              <select class="form-control" v-model="bodybuild">
                <option value="Fat">Fat</option>
                <option value="Muscular">Muscular</option>
                <option value="Normal/Medium">Normal/Medium</option>
                <option value="Strong">Strong</option>
                <option value="Thin">Thin</option>
                <option value="Very Fat">Very Fat</option>
                <option value="Very Lanky">Very Lanky</option>
              </select>
            </div>
          </div>
          <div class="col-md-3" v-if="faces == 'faces'">
            <div class="form-group label-floating">
              <label class="control-label" style="color: black !important;">Face</label>
              <select class="form-control" v-model="face">
                <option value="Square / Heavy Jaw">Square / Heavy Jaw</option>
                <option value="Square">Square</option>
                <option value="Receding ForeHead">Receding ForeHead</option>
                <option value="Oval">Oval</option>
                <option value="Protruding Face">Protruding Face</option>
                <option value="Long (Oval)">Long (Oval)</option>
                <option value="Wrinkled">Wrinkled</option>
                <option value="Round">Round</option>
                <option value="Normal">Normal</option>
              </select>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-md-4" v-if="activityLevels == 'activityLevels'">
            <div class="form-group label-floating">
              <label class="control-label" style="color: black !important;">Activity Level</label>
              <select class="form-control" v-model="activityLevel">
                <option value="Highly dangerous">Highly dangerous</option>
                <option value="Dangerous">Dangerous</option>
                <option value="Harmless">Harmless</option>
                <option value="Unknown">Inactive</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4" v-if="threatLevels == 'threatLevels'">
            <div class="form-group label-floating">
              <label class="control-label" style="color: black !important;">Threat Level</label>
              <select class="form-control" v-model="threatLevel">
                <option value="Absconder">Absconder</option>
                <option value="Highly Active">Highly Active</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
                <option value="Dormant">Dormant</option>
                <option value="No More involved">No Moreinvolved</option>
              </select>
            </div>
          </div>
          <div class="col-md-4" v-if="expertises == 'expertises'">
            <div class="form-group label-floating">
              <label class="control-label" style="color: black !important;">Expertise</label>
              <select class="form-control" v-model="expertise">
                <option value="Elephant">Elephant</option>
                <option value="Poacher">Poacher</option>
                <option value="Tracker">Tracker</option>
                <option value="Middle man">Middle man</option>
                <option value="Bush Meat trader">Bush Meat trader</option>
                <option value="Sandal wood">Sandal wood</option>
                <option value="Gun Owner">Gun Owner</option>
                <option value="Carver">Carver</option>
                <option value="Financier">Financier</option>
                <option value="Tiger">Tiger</option>
                <option value="Leopard">Leopard</option>
                <option value="Teak">Teak</option>
                <option value="Wood cutter">Wood cutter</option>
                <option value="Ivory">Ivory</option>
                <option value="Seller">Seller</option>
                <option value="Pet / captive">Pet / captive</option>
                <option value="Wildlife Article">Wildlife Article</option>
                <option value="Black Smith">Black Smith</option>
                <option value="Explosive">Explosive</option>
                <option value="Weapon">Weapon</option>
                <option value="Poison">Poison</option>
                <option value="Snare">Snare</option>
                <option value="Trap">Trap</option>
                <option value="Smuggling">Smuggling</option>
                <option value="Wild animal">Wild animal</option>
                <option value="Canabis">Canabis</option>
                <option value="Wood">Wood</option>
                <option value="Encroachment">Encroachment</option>
                <option value="Fish">Fish</option>
                <option value="Plant">Plant</option>
              </select>
            </div>
          </div>
          <div class="col-md-4" v-if="habitss == 'habitss'">
            <div class="form-group label-floating">
              <label class="control-label" style="color: black !important;">Habits</label>
              <select class="form-control" v-model="habits">
                <option value="No Peculiarity">No Peculiarity</option>
                <option value="No Habit">No Habit</option>
                <option value="Gutka">Gutka</option>
                <option value="Snuff Taker">Snuff Taker</option>
                <option value="Smoker">Smoker</option>
                <option value="Race-Goer">Race-Goer</option>
                <option value="Prostitute Monger">Prostitute Monger</option>
                <option value="Stretching">Stretching</option>
                <option value="Homosexual">Homosexual</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="mb-2">Prominent Identification Marks</label>
              <div v-for="(mark, index) in prominentMarks" :key="index" class="mb-2 mt-2">
                <div class="row">
                  <div class="col-md-4">
                    <select v-model="mark.marktype" class="form-control">
                      <option value="">Select Mark Type</option>
                      <option value="Moles(Small)">Moles(Small)</option>
                      <option value="Black Marks(Large)">Black Marks(Large)</option>
                      <option value="Scar Marks">Scar Marks</option>
                      <option value="Burn Marks">Burn Marks</option>
                      <option value="Leucoderma (White Patches)">Leucoderma (White Patches)</option>
                      <option value="Tattoo Marks">Tattoo Marks</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <select v-model="mark.details" class="form-control">
                      <option value="">Select Mark Location</option>
                      <option value="Hand left-letter">Hand left-letter</option>
                      <option value="Thigh Left">Thigh Left</option>
                      <option value="Chest Left Side">Chest Left Side</option>
                      <option value="Stomach">Stomach</option>
                      <option value="Cheek right">Cheek right</option>
                      <option value="Cheek left">Cheek left</option>
                      <option value="Thigh Right">Thigh Right</option>
                      <option value="Back Right Side">Back Right Side</option>
                      <option value="Foot Left">Foot Left</option>
                      <option value="Back Left Side">Back Left Side</option>
                      <option value="Foot Right">Foot Right</option>
                      <option value="Forehead">Forehead</option>
                      <option value="Hand left">Hand left</option>
                      <option value="Forearm Right - Figure">Forearm Right - Figure</option>
                      <option value="Forearm Right - Letter">Forearm Right - Letter</option>
                      <option value="Shoulder Left">Shoulder Left</option>
                      <option value="Palm Right">Palm Right</option>
                      <option value="Finger(s) Right Hand">Finger(s) Right Hand</option>
                      <option value="Schoulder Right">Schoulder Right</option>
                    </select>
                  </div>
                  <div class="col-md-2">
                    <button type="button" class="btn btn-outline-danger" @click="removeMark(index)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
              <button type="button" class="btn btn-outline-primary btn-sm mt-2" @click="addMark">
                <i class="fa fa-plus mr-1"></i>Add Mark
              </button>
            </div>
          </div>
        </div>

        <!-- Criminal Information -->
        <div class="row mt-4">
          <div class="col-md-12">
            <h5 class="border-bottom pb-2">Criminal Information</h5>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Offences *</label>
              <input v-model="formData.offences" type="text" class="form-control" placeholder="Type of offences" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Species Involved</label>
              <select v-model="formData.species" class="form-control">
                <option value="">Select Species</option>
                <option v-for="species in speciesList" :key="species._id" :value="species.commonName">
                  {{ species.commonName }} ({{ species.scientificName }})
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Crime History & Police Accused</label>
              <textarea v-model="formData.CrimeHistoryPoliceAccused" class="form-control" rows="3"
                placeholder="Detailed crime history and police records"></textarea>
            </div>
          </div>
        </div>

        <!-- Vehicle & Weapons -->
        <div class="row mt-4">
          <div class="col-md-12">
            <h5 class="border-bottom pb-2">Vehicles & Weapons</h5>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Vehicles Owned</label>
              <div v-for="(vehicle, index) in vehiclesList" :key="index" class="mb-3 p-3 border rounded">
                <div class="row">
                  <div class="col-md-6">
                    <input v-model="vehicle.brand" type="text" class="form-control mb-2"
                      placeholder="Brand (e.g., Toyota)" />
                  </div>
                  <div class="col-md-6">
                    <input v-model="vehicle.model" type="text" class="form-control mb-2"
                      placeholder="Model/Year (e.g., 2020)" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <input v-model="vehicle.regno" type="text" class="form-control mb-2"
                      placeholder="Registration Number" />
                  </div>
                  <div class="col-md-6">
                    <input v-model="vehicle.color" type="text" class="form-control mb-2" placeholder="Color" />
                  </div>
                </div>
                <button type="button" class="btn btn-outline-danger btn-sm" @click="removeVehicle(index)">
                  <i class="fa fa-trash mr-1"></i>Remove Vehicle
                </button>
              </div>
              <button type="button" class="btn btn-outline-primary btn-sm mt-2" @click="addVehicle">
                <i class="fa fa-plus mr-1"></i>Add Vehicle
              </button>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Guns/Weapons</label>
              <div v-for="(weapon, index) in weaponsList" :key="index" class="mb-3 p-3 border rounded">
                <div class="row">
                  <div class="col-md-6">
                    <input v-model="weapon.guntype" type="text" class="form-control mb-2"
                      placeholder="Weapon Type (e.g., Pistol)" />
                  </div>
                  <div class="col-md-6">
                    <input v-model="weapon.gunno" type="text" class="form-control mb-2" placeholder="Weapon Number" />
                  </div>
                </div>
                <button type="button" class="btn btn-outline-danger btn-sm" @click="removeWeapon(index)">
                  <i class="fa fa-trash mr-1"></i>Remove Weapon
                </button>
              </div>
              <button type="button" class="btn btn-outline-primary btn-sm mt-2" @click="addWeapon">
                <i class="fa fa-plus mr-1"></i>Add Weapon
              </button>
            </div>
          </div>
        </div>

        <!-- Family Details -->
        <div class="row mt-4">
          <div class="col-md-12">
            <h5 class="border-bottom pb-2">Family Details</h5>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Father</label>
              <input v-model="familyDetails.father" type="text" class="form-control" placeholder="Father's Name" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Mother</label>
              <input v-model="familyDetails.mother" type="text" class="form-control" placeholder="Mother's Name" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Wife</label>
              <input v-model="familyDetails.wife" type="text" class="form-control" placeholder="Wife's Name" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Children</label>
              <div v-for="(child, index) in familyDetails.children" :key="index" class="mb-2">
                <div class="input-group">
                  <input v-model="familyDetails.children[index].name" type="text" class="form-control"
                    :placeholder="`Child ${index + 1} Name`" />
                  <div class="input-group-append" v-if="familyDetails.children.length > 1">
                    <button type="button" class="btn btn-outline-danger" @click="removeChild(index)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
              <button type="button" class="btn btn-outline-primary btn-sm mt-2" @click="addChild">
                <i class="fa fa-plus mr-1"></i>Add Child
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Siblings</label>
              <div v-for="(sibling, index) in familyDetails.siblings" :key="index" class="mb-2">
                <div class="input-group">
                  <input v-model="familyDetails.siblings[index].name" type="text" class="form-control"
                    :placeholder="`Sibling ${index + 1} Name`" />
                  <div class="input-group-append" v-if="familyDetails.siblings.length > 1">
                    <button type="button" class="btn btn-outline-danger" @click="removeSibling(index)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
              <button type="button" class="btn btn-outline-primary btn-sm mt-2" @click="addSibling">
                <i class="fa fa-plus mr-1"></i>Add Sibling
              </button>
            </div>
          </div>
        </div>

        <!-- File Uploads -->
        <div class="row mt-4">
          <div class="col-md-12">
            <h5 class="border-bottom pb-2">Documents & Images</h5>
            <!-- <div class="alert alert-info">
              <strong>File Upload Summary:</strong> {{ totalFileCount }}/{{ maxFileCount }} files uploaded
              <br>
              <small>
                • ID Proofs: {{ idProofs.length + existingIdProofs.length }}/5 | 
                • General Images: {{ images.length + existingImages.length }}/10 | 
                • Left Thumb: {{ (leftThumb || existingLeftThumb) ? '1/1' : '0/1' }}
              </small>
            </div> -->
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>ID Proofs ({{ idProofs.length + existingIdProofs.length }}/5 files)</label>
              <input type="file" multiple accept="image/*,.pdf" @change="handleIdProofsUpload" class="form-control-file"
                :disabled="idProofs.length + existingIdProofs.length >= 5" />
              <small class="text-muted">
                Upload ID proof documents ({{ 5 - (idProofs.length + existingIdProofs.length) }} more allowed)
              </small>
              <div v-if="idProofs.length > 0" class="mt-2">
                <small class="text-info">
                  <strong>Selected files:</strong> {{idProofs.map(f => f.name).join(', ')}}
                </small>
              </div>

              <!-- ID Proofs with Details -->
              <div v-if="idProofs.length > 0 || existingIdProofs.length > 0" class="mt-3">
                <h6>ID Proofs:</h6>

                <!-- New uploaded files with details -->
                <div v-for="(file, index) in idProofs" :key="`new-${index}`" class="mb-3 p-3 border rounded">
                  <div class="row">
                    <div class="col-md-4">
                      <img v-if="file.type.startsWith('image/')" :src="getFilePreview(file)" class="img-thumbnail"
                        style="width: 100px; height: 100px; object-fit: cover;" />
                      <div v-else class="img-thumbnail d-flex align-items-center justify-content-center"
                        style="width: 100px; height: 100px; background-color: #f8f9fa;">
                        <i class="fa fa-file-pdf-o fa-2x text-danger"></i>
                      </div>
                    </div>
                    <div class="col-md-8">
                      <div class="form-group">
                        <label>ID Type</label>
                        <select v-model="idProofDetails[index].idType" class="form-control form-control-sm">
                          <option value="">Select ID Type</option>
                          <option v-for="option in idTypeOptions" :key="option" :value="option">
                            {{ option }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>ID Number</label>
                        <input v-model="idProofDetails[index].idNumber" type="text" class="form-control form-control-sm"
                          placeholder="ID Number" />
                      </div>
                      <button type="button" class="btn btn-sm btn-danger" @click="removeIdProof(index)">
                        <i class="fa fa-trash mr-1"></i>Remove
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Existing files from database -->
                <div v-for="(proof, index) in existingIdProofs" :key="`existing-${index}`"
                  class="mb-3 p-3 border rounded">
                  <div class="row">
                    <div class="col-md-4">
                      <img :src="`http://3.109.132.76/document/get/${proof.image}`" class="img-thumbnail"
                        style="width: 100px; height: 100px; object-fit: cover;" @error="handleImageError" />
                    </div>
                    <div class="col-md-8">
                      <div class="form-group">
                        <label>ID Type</label>
                        <select v-model="existingIdProofDetails[index].idType" class="form-control form-control-sm">
                          <option value="">Select ID Type</option>
                          <option v-for="option in idTypeOptions" :key="option" :value="option">
                            {{ option }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>ID Number</label>
                        <input v-model="existingIdProofDetails[index].idNumber" type="text"
                          class="form-control form-control-sm" placeholder="ID Number" />
                      </div>
                      <button type="button" class="btn btn-sm btn-danger" @click="removeExistingIdProof(index)">
                        <i class="fa fa-trash mr-1"></i>Remove
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>General Images ({{ images.length + existingImages.length }}/10 files)</label>
              <input type="file" multiple accept="image/*" @change="handleImagesUpload" class="form-control-file"
                :disabled="images.length + existingImages.length >= 10" />
              <small class="text-muted">
                Upload general photos ({{ 10 - (images.length + existingImages.length) }} more allowed)
              </small>
              <div v-if="images.length > 0" class="mt-2">
                <small class="text-info">
                  <strong>Selected files:</strong> {{images.map(f => f.name).join(', ')}}
                </small>
              </div>

              <!-- General Images Preview -->
              <div v-if="images.length > 0 || existingImages.length > 0" class="mt-3">
                <h6>General Images:</h6>
                <div class="row">
                  <!-- New uploaded files -->
                  <div v-for="(file, index) in images" :key="`new-${index}`" class="col-md-4 mb-2">
                    <div class="position-relative">
                      <img :src="getFilePreview(file)" class="img-thumbnail"
                        style="width: 100px; height: 100px; object-fit: cover;" />
                      <button type="button" class="btn btn-sm btn-danger position-absolute" style="top: 0; right: 0;"
                        @click="removeImage(index)">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </div>

                  <!-- Existing files from database -->
                  <div v-for="(img, index) in existingImages" :key="`existing-${index}`" class="col-md-4 mb-2">
                    <div class="position-relative">
                      <img :src="`http://3.109.132.76/document/get/${img.path}`" class="img-thumbnail"
                        style="width: 100px; height: 100px; object-fit: cover;" @error="handleImageError" />
                      <button type="button" class="btn btn-sm btn-danger position-absolute" style="top: 0; right: 0;"
                        @click="removeExistingImage(index)">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Left Thumb Impression ({{ (leftThumb || existingLeftThumb) ? '1/1' : '0/1' }} files)</label>
              <input type="file" accept="image/*" @change="handleLeftThumbUpload" class="form-control-file"
                :disabled="leftThumb || existingLeftThumb" />
              <small class="text-muted">
                Upload left thumb impression ({{ (leftThumb || existingLeftThumb) ? '0' : '1' }} more allowed)
              </small>
              <div v-if="leftThumb" class="mt-2">
                <small class="text-info">
                  <strong>Selected file:</strong> {{ leftThumb.name }}
                </small>
              </div>

              <!-- Left Thumb Preview -->
              <div v-if="leftThumb || existingLeftThumb" class="mt-3">
                <h6>Left Thumb Impression:</h6>
                <div class="position-relative d-inline-block">
                  <img v-if="leftThumb" :src="getFilePreview(leftThumb)" class="img-thumbnail"
                    style="width: 150px; height: 150px; object-fit: cover;" />
                  <img v-else-if="existingLeftThumb" :src="`http://3.109.132.76/document/get/${existingLeftThumb}`"
                    class="img-thumbnail" style="width: 150px; height: 150px; object-fit: cover;"
                    @error="handleImageError" />
                  <button type="button" class="btn btn-sm btn-danger position-absolute" style="top: 0; right: 0;"
                    @click="removeLeftThumb">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Signature ({{ (signature || existingSignature) ? '1/1' : '0/1' }} files)</label>
              <input type="file" accept="image/*" @change="handleSignatureUpload" class="form-control-file"
                :disabled="signature || existingSignature" />
              <small class="text-muted">
                Upload signature image ({{ (signature || existingSignature) ? '0' : '1' }} more allowed)
              </small>
              <div v-if="signature" class="mt-2">
                <small class="text-info">
                  <strong>Selected file:</strong> {{ signature.name }}
                </small>
              </div>

              <!-- Signature Preview -->
              <div v-if="signature || existingSignature" class="mt-3">
                <h6>Signature:</h6>
                <div class="position-relative d-inline-block">
                  <img v-if="signature" :src="getFilePreview(signature)" class="img-thumbnail"
                    style="width: 150px; height: 150px; object-fit: cover;" />
                  <img v-else-if="existingSignature" :src="`http://3.109.132.76/document/get/${existingSignature}`"
                    class="img-thumbnail" style="width: 150px; height: 150px; object-fit: cover;"
                    @error="handleImageError" />
                  <button type="button" class="btn btn-sm btn-danger position-absolute" style="top: 0; right: 0;"
                    @click="removeSignature">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Submit Buttons -->
        <div class="row mt-4">
          <div class="col-md-12 text-center">
            <b-button type="submit" variant="success" size="lg" :disabled="visible" class="mr-3">
              <i class="fa fa-save mr-2"></i>
              {{ isEditMode ? 'Update' : 'Save' }} Offender
            </b-button>
            <b-button type="button" variant="secondary" size="lg" @click="handleCancel">
              Cancel
            </b-button>
          </div>
        </div>

        <!-- Manual Navigation Button (shown if automatic navigation fails) -->
        <div v-if="showManualNavigation" class="row mt-3">
          <div class="col-md-12 text-center">
            <div class="alert alert-warning">
              <strong>Navigation Issue Detected!</strong>
              <br>Please click the button below to go back to the offenders list.
              <br><br>
              <b-button variant="primary" @click="manualNavigateToOffenders">
                <i class="fa fa-arrow-left mr-2"></i>
                Go to Offenders List
              </b-button>
            </div>
          </div>
        </div>
      </form>
    </va-card>
  </div>
</template>

<script>
import axios from "axios";
import VueElementLoading from "vue-element-loading";

export default {
  name: "AddOffender",
  components: {
    VueElementLoading
  },
  data() {
    return {
      visible: false,
      isEditMode: false,
      offenderId: null,
      showManualNavigation: false,
      formData: {
        name: "",
        alias: "",
        age: "",
        adharNo: "",
        sex: "",
        address: "",
        fathersName: "",
        occupation: "",
        height: "",
        contactNo: "",
        dob: "",
        CrimeHistoryPoliceAccused: "",
        signature: "",
        isHabitual: false,
        species: ""
      },
      phoneNumbers: [""],
      prominentMarks: [{ marktype: "", details: "" }],
      vehiclesList: [{ brand: "", model: "", regno: "", color: "" }],
      weaponsList: [{ guntype: "", gunno: "" }],
      familyDetails: {
        father: "",
        mother: "",
        wife: "",
        children: [{ name: "" }],
        siblings: [{ name: "" }]
      },
      idProofs: [],
      images: [],
      leftThumb: null,
      existingIdProofs: [],
      existingImages: [],
      existingLeftThumb: null,
      idProofDetails: [],
      existingIdProofDetails: [],
      signature: null, // New data property for signature
      existingSignature: null, // New data property for existing signature
      // Dropdown control variables
      expertises: 'expertises',
      eyess: 'eyess',
      hairs: 'hairs',
      bodybuilds: 'bodybuilds',
      faces: 'faces',
      habitss: 'habitss',
      idmarks: 'idmarks',
      activityLevels: 'activityLevels',
      threatLevels: 'threatLevels',
      complexions: 'complexions',
      // Dropdown values
      expertise: '',
      eyes: '',
      hair: '',
      bodybuild: '',
      face: '',
      habits: '',
      activityLevel: '',
      threatLevel: '',
      complexion: '', // New data property for complexion
      // ID Type dropdown options
      idTypeOptions: [
        'Aadhar Card',
        'PAN Card',
        'Driving License',
        'Voter ID',
        // 'Passport',
        // 'Ration Card',
        // 'Birth Certificate',
        // 'School Certificate',
        // 'College Certificate',
        // 'Bank Passbook',
        // 'Electricity Bill',
        // 'Water Bill',
        // 'Gas Bill',
        // 'Telephone Bill',
        // 'Mobile Bill',
        // 'Rent Agreement',
        // 'Property Documents',
        // 'Insurance Card',
        // 'Medical Card',
        'Other'
      ],
      aadhaarValidation: {
        isLoading: false,
        isValid: false,
        isInvalid: false,
        exists: false,
        existingData: null
      },
      aadhaarValidationTimeout: null,
      originalAdharNo: '', // New data property to store original Aadhar number
      speciesList: [] // To store species from Digital Guide
    };
  },
  computed: {
    totalFileCount() {
      return (this.idProofs.length + this.existingIdProofs.length) +
        (this.images.length + this.existingImages.length) +
        ((this.leftThumb || this.existingLeftThumb) ? 1 : 0) + // Left thumb
        ((this.signature || this.existingSignature) ? 1 : 0); // Signature
    },
    maxFileCount() {
      return 17; // 5 ID proofs + 10 images + 1 left thumb + 1 signature
    }
  },
  async mounted() {
    this.fetchSpecies();
    // Check if we're in edit mode
    if (this.$route.query.id) {
      this.isEditMode = true;
      this.offenderId = this.$route.query.id;
      await this.fetchOffenderData();
    }
  },
  methods: {
    async fetchOffenderData() {
      this.visible = true;
      try {
        const response = await axios.get(`/habitual/${this.offenderId}`);
        if (response.data.status) {
          const offender = response.data.data;
          this.populateForm(offender);
        } else {
          alert('Offender not found');
          this.$router.push('/offenders');
        }
      } catch (error) {
        console.error('Error fetching offender data:', error);
        alert('Failed to fetch offender data');
        this.$router.push('/offenders');
      } finally {
        this.visible = false;
      }
    },

    populateForm(offender) {
      // Basic form data
      this.formData = {
        name: offender.name || "",
        alias: offender.alias || "",
        age: offender.age || "",
        adharNo: offender.adharNo || "",
        sex: offender.sex || "",
        address: offender.address || "",
        fathersName: offender.fathersName || "",
        occupation: offender.occupation || "",
        offences: this.formatOffences(offender.offences) || "",
        height: offender.height || "",
        contactNo: offender.contactNo || "",
        dob: offender.dob ? new Date(offender.dob).toISOString().split('T')[0] : "",
        CrimeHistoryPoliceAccused: offender.CrimeHistoryPoliceAccused || "",
        signature: offender.signature || "",
        isHabitual: offender.isHabitual || false,
        species: offender.species || ""
      };

      // Phone numbers
      if (offender.phone && offender.phone.length > 0) {
        this.phoneNumbers = offender.phone.map(phone => phone.mobile || phone);
      } else {
        this.phoneNumbers = [""];
      }

      // Prominent marks
      if (offender.prominentIdentificationMarks && offender.prominentIdentificationMarks.length > 0) {
        this.prominentMarks = offender.prominentIdentificationMarks.map(mark => ({
          marktype: mark.marktype || "",
          details: mark.details || ""
        }));
      } else {
        this.prominentMarks = [{ marktype: "", details: "" }];
      }

      // Vehicles
      if (offender.vehicleOwned && offender.vehicleOwned.length > 0) {
        this.vehiclesList = offender.vehicleOwned.map(vehicle => ({
          brand: vehicle.brand || "",
          model: vehicle.model || "",
          regno: vehicle.regno || "",
          color: vehicle.color || ""
        }));
      } else {
        this.vehiclesList = [{ brand: "", model: "", regno: "", color: "" }];
      }

      // Weapons
      if (offender.gun && offender.gun.length > 0) {
        this.weaponsList = offender.gun.map(weapon => ({
          guntype: weapon.guntype || "",
          gunno: weapon.gunno || ""
        }));
      } else {
        this.weaponsList = [{ guntype: "", gunno: "" }];
      }

      // Family details
      if (offender.familyDetails) {
        this.familyDetails = {
          father: offender.familyDetails.father || "",
          mother: offender.familyDetails.mother || "",
          wife: offender.familyDetails.wife || "",
          children: offender.familyDetails.children && offender.familyDetails.children.length > 0
            ? offender.familyDetails.children.map(child => ({ name: child.name || child }))
            : [{ name: "" }],
          siblings: offender.familyDetails.siblings && offender.familyDetails.siblings.length > 0
            ? offender.familyDetails.siblings.map(sibling => ({ name: sibling.name || sibling }))
            : [{ name: "" }]
        };
      } else {
        this.familyDetails = {
          father: "",
          mother: "",
          wife: "",
          children: [{ name: "" }],
          siblings: [{ name: "" }]
        };
      }

      // Handle existing images
      this.existingIdProofs = offender.idproofs || [];
      this.existingImages = offender.image || [];
      this.existingLeftThumb = offender.leftThumb || null;
      this.existingSignature = offender.signature || null; // Populate existing signature

      // Store original Aadhar number for edit mode validation
      this.originalAdharNo = offender.adharNo || '';

      // Initialize existing ID proof details
      this.existingIdProofDetails = this.existingIdProofs.map(proof => ({
        idType: proof.idType || '',
        idNumber: proof.idNumber || ''
      }));

      // Populate dropdown values
      // Handle expertise - check both uppercase and lowercase versions
      if (offender.expertise) {
        this.expertise = offender.expertise;
      } else if (offender.Expertise && Array.isArray(offender.Expertise) && offender.Expertise.length > 0) {
        this.expertise = offender.Expertise[0]; // Take the first value from the array
      } else if (offender.Expertise && typeof offender.Expertise === 'string') {
        this.expertise = offender.Expertise;
      } else {
        this.expertise = '';
      }

      this.eyes = offender.eyes || '';
      this.hair = offender.hair || '';
      this.bodybuild = offender.bodybuild || '';
      this.face = offender.face || '';
      this.complexion = offender.complexion || ''; // Populate complexion

      // Handle habits - it might come as an array from the backend
      if (Array.isArray(offender.habits) && offender.habits.length > 0) {
        this.habits = offender.habits[0]; // Take the first value from the array
      } else if (typeof offender.habits === 'string') {
        this.habits = offender.habits;
      } else {
        this.habits = '';
      }

      this.activityLevel = offender.activityLevel || '';
      this.threatLevel = offender.threatLevel || '';
    },

    formatOffences(offences) {
      if (!offences) return "";

      // If offences is already a string, return it as is
      if (typeof offences === 'string') return offences;

      // If offences is an array, extract the names and join them
      if (Array.isArray(offences)) {
        return offences.map(offence => {
          if (typeof offence === 'string') return offence;
          if (offence && typeof offence === 'object' && offence.name) return offence.name;
          return '';
        }).filter(name => name.trim() !== '').join(', ');
      }

      return "";
    },

    handleIdProofsUpload(event) {
      const newFiles = Array.from(event.target.files);
      const maxIdProofs = 5;
      const currentTotal = this.idProofs.length + this.existingIdProofs.length;

      if (currentTotal + newFiles.length > maxIdProofs) {
        alert(`Maximum ${maxIdProofs} ID proof files allowed. You can upload ${maxIdProofs - currentTotal} more files.`);
        event.target.value = '';
        return;
      }

      // Append new files to existing ones instead of replacing
      this.idProofs = [...this.idProofs, ...newFiles];

      // Initialize details for each new file (only for the newly added ones)
      const newDetails = newFiles.map(() => ({ idType: '', idNumber: '' }));
      this.idProofDetails = [...this.idProofDetails, ...newDetails];

      // Clear the input so the same file can be selected again if needed
      event.target.value = '';

      // Show success message
      // alert(`${newFiles.length} ID proof file(s) added successfully!`);
    },

    handleImagesUpload(event) {
      const newFiles = Array.from(event.target.files);
      const maxImages = 10;
      const currentTotal = this.images.length + this.existingImages.length;

      if (currentTotal + newFiles.length > maxImages) {
        alert(`Maximum ${maxImages} general image files allowed. You can upload ${maxImages - currentTotal} more files.`);
        event.target.value = '';
        return;
      }

      // Append new files to existing ones instead of replacing
      this.images = [...this.images, ...newFiles];

      // Clear the input so the same file can be selected again if needed
      event.target.value = '';

      // Show success message
      // alert(`${newFiles.length} general image file(s) added successfully!`);
    },

    handleLeftThumbUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.leftThumb = file;
        // Show success message
        // alert('Left thumb impression uploaded successfully!');
        // Clear the input
        event.target.value = '';
      }
    },

    handleSignatureUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.signature = file;
        // Show success message
        // alert('Signature uploaded successfully!');
        // Clear the input
        event.target.value = '';
      }
    },

    getFilePreview(file) {
      return URL.createObjectURL(file);
    },

    handleImageError(event) {
      event.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBmaWxsPSIjRjVGNUY1Ii8+Cjx0ZXh0IHg9IjUwIiB5PSI1MCIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEyIiBmaWxsPSIjOTk5IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+SW1hZ2U8L3RleHQ+Cjx0ZXh0IHg9IjUwIiB5PSI2NSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEyIiBmaWxsPSIjOTk5IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+Tm90IEZvdW5kPC90ZXh0Pgo8L3N2Zz4K';
    },

    removeIdProof(index) {
      this.idProofs.splice(index, 1);
      this.idProofDetails.splice(index, 1);
      // Re-enable file input if we're under the limit
      this.$nextTick(() => {
        const fileInput = this.$el.querySelector('input[type="file"][multiple][accept="image/*,.pdf"]');
        if (fileInput && this.idProofs.length + this.existingIdProofs.length < 5) {
          fileInput.disabled = false;
        }
      });
    },

    removeExistingIdProof(index) {
      this.existingIdProofs.splice(index, 1);
      this.existingIdProofDetails.splice(index, 1);
      // Re-enable file input if we're under the limit
      this.$nextTick(() => {
        const fileInput = this.$el.querySelector('input[type="file"][multiple][accept="image/*,.pdf"]');
        if (fileInput && this.idProofs.length + this.existingIdProofs.length < 5) {
          fileInput.disabled = false;
        }
      });
    },

    removeImage(index) {
      this.images.splice(index, 1);
      // Re-enable file input if we're under the limit
      this.$nextTick(() => {
        const fileInput = this.$el.querySelector('input[type="file"][multiple][accept="image/*"]');
        if (fileInput && this.images.length + this.existingImages.length < 10) {
          fileInput.disabled = false;
        }
      });
    },

    removeExistingImage(index) {
      this.existingImages.splice(index, 1);
      // Re-enable file input if we're under the limit
      this.$nextTick(() => {
        const fileInput = this.$el.querySelector('input[type="file"][multiple][accept="image/*"]');
        if (fileInput && this.images.length + this.existingImages.length < 10) {
          fileInput.disabled = false;
        }
      });
    },

    removeLeftThumb() {
      this.leftThumb = null;
      this.existingLeftThumb = null;
      // Re-enable file input
      this.$nextTick(() => {
        const fileInput = this.$el.querySelector('input[type="file"][accept="image/*"]:not([multiple])');
        if (fileInput) {
          fileInput.disabled = false;
        }
      });
    },

    removeSignature() {
      this.signature = null;
      this.existingSignature = null;
      // Re-enable file input
      this.$nextTick(() => {
        const fileInput = this.$el.querySelector('input[type="file"][accept="image/*"]:not([multiple])');
        if (fileInput) {
          fileInput.disabled = false;
        }
      });
    },

    addPhone() {
      this.phoneNumbers.push("");
    },

    removePhone(index) {
      this.phoneNumbers.splice(index, 1);
    },

    addMark() {
      this.prominentMarks.push({ marktype: "", details: "" });
    },

    removeMark(index) {
      this.prominentMarks.splice(index, 1);
    },

    addVehicle() {
      this.vehiclesList.push({ brand: "", model: "", regno: "", color: "" });
    },

    removeVehicle(index) {
      this.vehiclesList.splice(index, 1);
    },

    addWeapon() {
      this.weaponsList.push({ guntype: "", gunno: "" });
    },

    removeWeapon(index) {
      this.weaponsList.splice(index, 1);
    },

    addChild() {
      this.familyDetails.children.push({ name: "" });
    },

    removeChild(index) {
      this.familyDetails.children.splice(index, 1);
    },

    addSibling() {
      this.familyDetails.siblings.push({ name: "" });
    },

    removeSibling(index) {
      this.familyDetails.siblings.splice(index, 1);
    },

    clearForm() {
      // Reset all form data to initial state
      this.formData = {
        name: "",
        alias: "",
        age: "",
        adharNo: "",
        sex: "",
        address: "",
        fathersName: "",
        occupation: "",
        offences: "",
        height: "",
        contactNo: "",
        dob: "",
        CrimeHistoryPoliceAccused: "",
        signature: "",
        face: "",
        hair: "",
        bodybuild: "",
        eyes: "",
        complexion: "", // Clear complexion
        isHabitual: false,
        species: ""
      };

      // Reset arrays and objects
      this.phoneNumbers = [""];
      this.prominentMarks = [{ marktype: "", details: "" }];
      this.vehiclesList = [{ brand: "", model: "", regno: "", color: "" }];
      this.weaponsList = [{ guntype: "", gunno: "" }];
      this.familyDetails = {
        father: "",
        mother: "",
        wife: "",
        children: [{ name: "" }],
        siblings: [{ name: "" }]
      };

      // Clear all files
      this.idProofs = [];
      this.images = [];
      this.leftThumb = null;
      this.signature = null; // Clear signature
      this.existingIdProofs = [];
      this.existingImages = [];
      this.existingLeftThumb = null;
      this.existingSignature = null; // Clear existing signature
      this.idProofDetails = [];
      this.existingIdProofDetails = [];

      // Reset dropdown values
      this.expertise = '';
      this.eyes = '';
      this.hair = '';
      this.bodybuild = '';
      this.face = '';
      this.habits = '';
      this.activityLevel = '';
      this.threatLevel = '';
      this.complexion = ''; // Reset complexion

      // Reset Aadhaar validation
      this.aadhaarValidation = {
        isLoading: false,
        isValid: false,
        isInvalid: false,
        exists: false,
        existingData: null
      };

      // Clear validation timeout
      if (this.aadhaarValidationTimeout) {
        clearTimeout(this.aadhaarValidationTimeout);
        this.aadhaarValidationTimeout = null;
      }

      // Reset original Aadhar number
      this.originalAdharNo = '';

      // Reset edit mode
      this.isEditMode = false;
      this.offenderId = null;
    },

    handleCancel() {
      // Navigate back to offenders list
      this.$router.push('/offenders');
    },

    navigateToOffenders() {
      // Try multiple navigation methods to ensure it works
      console.log('Attempting to navigate to /offenders...');

      // Method 1: Try router.push with name
      this.$router.push({ name: 'offenders' }).catch(err => {
        console.error('Router.push with name failed:', err);

        // Method 2: Try router.push with path
        this.$router.push('/offenders').catch(pathErr => {
          console.error('Router.push with path failed:', pathErr);

          // Method 3: Try router.replace
          this.$router.replace('/offenders').catch(replaceErr => {
            console.error('Router.replace failed:', replaceErr);

            // Method 4: Try window.location.href
            console.log('Using window.location.href fallback');
            try {
              window.location.href = '/offenders';
            } catch (locationErr) {
              console.error('window.location.href failed:', locationErr);

              // Method 5: Final fallback - force page reload
              console.log('Using final fallback - page reload');
              window.location.reload();
            }
          });
        });
      });
    },

    manualNavigateToOffenders() {
      console.log('Manual navigation triggered');
      this.showManualNavigation = false;

      // Try all navigation methods
      try {
        this.$router.push('/offenders');
      } catch (err) {
        console.error('Manual router.push failed:', err);
        try {
          window.location.href = '/offenders';
        } catch (locationErr) {
          console.error('Manual window.location failed:', locationErr);
          window.location.reload();
        }
      }
    },

    async submitForm() {
      // Validate file counts before submission
      const totalFiles = this.totalFileCount;
      if (totalFiles > this.maxFileCount) {
        alert(`Maximum ${this.maxFileCount} files allowed. You have ${totalFiles} files selected.`);
        return;
      }

      this.visible = true;
      try {
        const formData = new FormData();

        // Add basic form fields
        Object.keys(this.formData).forEach(key => {
          formData.append(key, this.formData[key]);
        });

        // Add dropdown values (these override formData values)
        formData.append('expertise', this.expertise);
        formData.append('eyes', this.eyes);
        formData.append('hair', this.hair);
        formData.append('bodybuild', this.bodybuild);
        formData.append('face', this.face);
        formData.append('habits', this.habits);
        formData.append('activityLevel', this.activityLevel);
        formData.append('threatLevel', this.threatLevel);
        formData.append('complexion', this.complexion); // Append complexion

        // Convert phone numbers to proper format
        const phoneData = this.phoneNumbers
          .filter(phone => phone.trim() !== "")
          .map(phone => ({ mobile: phone.trim() }));

        formData.append('phone', JSON.stringify(phoneData));

        // Convert prominent marks to proper format
        const marksData = this.prominentMarks
          .filter(mark => mark.marktype && mark.details)
          .map(mark => ({ marktype: mark.marktype, details: mark.details }));

        formData.append('prominentIdentificationMarks', JSON.stringify(marksData));

        // Convert vehicles to proper format
        const vehiclesData = this.vehiclesList
          .filter(vehicle => vehicle.brand || vehicle.model || vehicle.regno || vehicle.color);

        formData.append('vehicleOwned', JSON.stringify(vehiclesData));

        // Convert weapons to proper format
        const weaponsData = this.weaponsList
          .filter(weapon => weapon.guntype || weapon.gunno);

        formData.append('gun', JSON.stringify(weaponsData));

        // Convert family details to proper format
        const familyData = {
          father: this.familyDetails.father,
          mother: this.familyDetails.mother,
          wife: this.familyDetails.wife,
          children: this.familyDetails.children.filter(child => child.name.trim() !== ""),
          siblings: this.familyDetails.siblings.filter(sibling => sibling.name.trim() !== "")
        };

        formData.append('familyDetails', JSON.stringify(familyData));

        // Add new files
        this.idProofs.forEach((file, index) => {
          formData.append('idproofs', file);
          const details = this.idProofDetails[index] || {};
          formData.append(`idproofs[${index}].idType`, details.idType || 'ID Proof');
          formData.append(`idproofs[${index}].idNumber`, details.idNumber || 'N/A');
        });

        this.images.forEach(file => {
          formData.append('images', file);
        });

        if (this.leftThumb) {
          formData.append('leftThumb', this.leftThumb);
        }

        if (this.signature) {
          formData.append('signature', this.signature);
        }

        // Add existing files that weren't removed (with updated details)
        if (this.isEditMode) {
          // Merge existing ID proofs with their updated details
          const updatedExistingIdProofs = this.existingIdProofs.map((proof, index) => ({
            ...proof,
            idType: (this.existingIdProofDetails[index] && this.existingIdProofDetails[index].idType) || proof.idType || '',
            idNumber: (this.existingIdProofDetails[index] && this.existingIdProofDetails[index].idNumber) || proof.idNumber || ''
          }));

          formData.append('existingIdProofs', JSON.stringify(updatedExistingIdProofs));
          formData.append('existingImages', JSON.stringify(this.existingImages));
          if (this.existingLeftThumb) {
            formData.append('existingLeftThumb', this.existingLeftThumb);
          }
          if (this.existingSignature) {
            formData.append('existingSignature', this.existingSignature);
          }
        }

        // Debug logging for edit mode
        if (this.isEditMode) {
          console.log('Edit Mode - Files being sent:');
          console.log('New ID Proofs:', this.idProofs.length);
          console.log('Existing ID Proofs:', this.existingIdProofs.length);
          console.log('New Images:', this.images.length);
          console.log('Existing Images:', this.existingImages.length);
          console.log('Total files:', this.totalFileCount);
        }

        let response;
        if (this.isEditMode) {
          // Update existing offender
          response = await axios.put(`/habitual/${this.offenderId}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
        } else {
          // Add new offender
          response = await axios.post('/habitual/add', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
        }


        if (response.data.status) {
          console.log('Form submission successful!');
          console.log('Response data:', response.data);
          console.log('response.data.status:', response.data.status);

          // Show success message (using alert since toast is not working)
          // if (this.isEditMode) {
          //   alert(`Offender updated successfully! Total files: ${this.totalFileCount}`);
          // } else {
          //   alert('Offender added successfully!');
          // }

          // Navigate immediately after showing success message
          console.log('=== NAVIGATION DEBUG START ===');
          console.log('Form submission successful, attempting navigation...');
          console.log('Current route:', this.$route.path);
          console.log('Router mode:', this.$router.mode);
          console.log('Router instance:', this.$router);

          // Try multiple navigation approaches
          let navigationAttempted = false;

          // Method 1: Direct router.push
          try {
            console.log('Attempting direct router.push...');
            this.$router.push('/offenders');
            console.log('Router.push called successfully');
            navigationAttempted = true;
          } catch (directErr) {
            console.error('Direct navigation failed:', directErr);

            // Try router.replace as alternative
            try {
              console.log('Attempting router.replace...');
              this.$router.replace('/offenders');
              console.log('Router.replace called successfully');
              navigationAttempted = true;
            } catch (replaceErr) {
              console.error('Router.replace also failed:', replaceErr);
            }
          }

          // Method 2: If direct failed, try with setTimeout
          if (!navigationAttempted) {
            setTimeout(() => {
              console.log('Trying navigation with setTimeout...');
              try {
                this.$router.push('/offenders');
                console.log('Navigation with setTimeout successful');
              } catch (timeoutErr) {
                console.error('Navigation with setTimeout failed:', timeoutErr);

                // Method 3: Try window.location as final fallback
                console.log('Using window.location fallback...');
                try {
                  window.location.href = '/offenders';
                } catch (locationErr) {
                  console.error('All automatic navigation methods failed');
                  console.log('Showing manual navigation button');
                  this.showManualNavigation = true;
                }
              }
            }, 1000);
          }

          console.log('=== NAVIGATION DEBUG END ===');

          // Hide loading spinner after navigation attempt
          this.visible = false;
        } else {
          alert(response.data.message || (this.isEditMode ? 'Failed to update offender' : 'Failed to add offender'));
          this.visible = false; // Hide loading on error
        }
      } catch (error) {
        console.error('Error submitting form:', error);
        alert(this.isEditMode ? 'Failed to update offender. Please try again.' : 'Failed to add offender. Please try again.');
        this.visible = false; // Hide loading on error
      }
    },

    async validateAadhaar(event) {
      const isBlur = event && event.type === 'blur';
      let adharNo = this.formData.adharNo ? this.formData.adharNo.toString().trim() : '';
      
      // Update the form data with trimmed value
      this.formData.adharNo = adharNo;

      // Clear previous timeout
      if (this.aadhaarValidationTimeout) {
        clearTimeout(this.aadhaarValidationTimeout);
      }

      // Reset validation state
      this.aadhaarValidation = {
        isLoading: false,
        isValid: false,
        isInvalid: false,
        exists: false,
        existingData: null
      };

      if (!adharNo) {
        return;
      }

      // Check for non-digit characters immediately
      if (!/^\d+$/.test(adharNo)) {
        this.aadhaarValidation.isInvalid = true;
        return;
      }

      // In edit mode, skip validation if Aadhaar number hasn't changed
      if (this.isEditMode && adharNo === this.originalAdharNo) {
        this.aadhaarValidation.isValid = true;
        return;
      }

      // Handle length validation
      if (adharNo.length < 12) {
        // Only show invalid if the user has finished typing (blur)
        if (isBlur) {
          this.aadhaarValidation.isInvalid = true;
        }
        return;
      }

      // If exactly 12 digits, proceed to API check
      if (adharNo.length === 12) {
        // Set loading state
        this.aadhaarValidation.isLoading = true;

        // Debounce the API call
        this.aadhaarValidationTimeout = setTimeout(async () => {
          try {
            const response = await axios.get(`/habitual/check-aadhaar/${adharNo}`);

            if (response.data.status) {
              this.aadhaarValidation.isValid = true;
              this.aadhaarValidation.exists = response.data.exists;

              if (response.data.exists && response.data.data) {
                this.aadhaarValidation.existingData = response.data.data;
              }
            } else {
              // Only treat as invalid format if API specifically fails status check
              this.aadhaarValidation.isInvalid = true;
            }
          } catch (error) {
            console.error('Error validating Aadhaar:', error);
            // On API error, we don't necessarily mark as invalid format, 
            // but we reset loading
          } finally {
            this.aadhaarValidation.isLoading = false;
          }
        }, 500); // 500ms delay
      }
    },
    async fetchSpecies() {
      try {
        const response = await axios.post('/digitalguide/list', {
          page: 1,
          limit: 1000, // Fetch a large number to populate the dropdown
          status: 'active'
        });
        if (response.data.status) {
          this.speciesList = response.data.data;
        }
      } catch (error) {
        console.error('Error fetching species:', error);
      }
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 1rem;
}

.form-control {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 12px;
}

.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-control-file:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.border-bottom {
  border-bottom: 2px solid #007bff !important;
}

h5 {
  color: #007bff;
  font-weight: 600;
}

.alert-info {
  background-color: #d1ecf1;
  border-color: #bee5eb;
  color: #0c5460;
}

.alert-info strong {
  color: #0c5460;
}
</style>
